<template>
    <div class="project">
        <advertising-figure :bannerSrc="bannerSrc"/>
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Meettingplace of the meeting</span>
            </public-title>

            <div class="divider">
                <h2 class="tit">交通信息</h2>
                <span class="time">发布日期: 2022-1-15</span>
            </div>

            <div class="traffic-wrap">
                <h2 class="tit">这是一个很厉害的项目</h2>
                <div class="traffic">
                    <div class="map-wrap">
                        <hotel-where :height="mapHeight" />
                    </div>
                    <div class="article introduce">
                        <h3 class="sub-tit">交通线路一:</h3>
                        <p class="info">
                            这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目
                        </p>
                    </div>
                    <div class="article details">
                        <h3 class="sub-tit">交通线路二:</h3>
                        <p class="info">
                            这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目这是一个很厉害的项目
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdvertisingFigure from "@components/advertising";
import InnerPageNav from "@components/tool-nav";
import publicTitle from "@components/title";

import hotelWhere from '@components/map'

export default {
    name: "TrafficPage",
    components: {
        AdvertisingFigure,
        InnerPageNav,
        publicTitle,
        hotelWhere
    },

    data() {
        return {
            bannerSrc:require("@assets/img/meeting-banner.png"),
            title: "会场信息",
            mapHeight: "400px"
        };
    },

    methods: {},
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/innerpagenav.scss";

.inner-page-nav {
    position: relative;
    width: 1200px;
    height: 60px;
    padding: 0 15px;
    margin: 0 auto;
}

.inner-page-content {
    margin: 60px 0;
}

.divider {
    @include flex-between;
    width: 1200px;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    margin: 30px auto 60px;
    border-bottom: 1px solid #eee;

    .tit {
        position: relative;
        font-size: 18px;
        color: #666;

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 2px;
            background: $defaultColor;
        }
    }

    .time {
        font-size: 14px;
        color: #999;
    }
}

.traffic-wrap {
    width: 1200px;
    margin: 30px auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);

    .tit {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: inline-block;
        min-width: 180px;
        font-size: 20px;
        margin: 30px 0;
        color: $defaultColor;
        padding: 0 30px;
        text-align: center;

        &:before {
            content: "";
            position: absolute;
            top: 50%;
            left: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to right, transparent, #ccc);
        }

        &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: -100px;
            width: 100px;
            height: 2px;
            background: linear-gradient(to left, transparent, #ccc);
        }
    }

    .traffic {
        position: relative;
        padding: 30px;
        margin-bottom: 30px;
        min-height: 180px;

        .article {
            margin-top: 30px;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;

            .sub-tit {
                font-size: 16px;
                margin-bottom: 10px;
                color: $defaultColor;
            }

            .info {
                font-size: 14px;
                line-height: 30px;
                color: #666;
            }
        }
    }
}
</style>